import { render, staticRenderFns } from "./ManageCommpanyBrandDetail.vue?vue&type=template&id=40a2babf&"
import script from "./ManageCommpanyBrandDetail.vue?vue&type=script&lang=js&"
export * from "./ManageCommpanyBrandDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports